import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/guides",
    element: <Home />,
  },
  {
    path: "/reviews",
    element: <Home />,
  },
  {
    path: "/shipping",
    element: <Home />,
  },
  {
    path: "/safety",
    element: <Home />,
  },
  {
    path: "/about",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <Home />,
  },
  {
    path: "/terms",
    element: <Home />,
  },
  {
    path: "/disclaimer",
    element: <Home />,
  },
  {
    path: "/contact",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;